import { render, staticRenderFns } from "./NotificationAlerts.vue?vue&type=template&id=52e624e5&scoped=true"
import script from "./NotificationAlerts.vue?vue&type=script&lang=js"
export * from "./NotificationAlerts.vue?vue&type=script&lang=js"
import style0 from "./NotificationAlerts.vue?vue&type=style&index=0&id=52e624e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e624e5",
  null
  
)

export default component.exports